import { h, Component, Fragment } from "preact";
import PropTypes from "prop-types";
import { sendRequest, validateFiles } from "../../tools";
import CameraButton from "./CameraButton";
import FileInput from "./FileInput";
import Modal from "./Modal";
import { allowedFileTypes, maxCountFile, maxSizeFile } from "../../helper";

export default class AppealCommentForm extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    appealId: PropTypes.string.isRequired,
    available: PropTypes.bool.isRequired,
    onSubmited: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      values: {
        files: [],
      },
      loading: false,
      modalCamera: false,
      available: props.available,
      error: [],
    };
    this.submitted = false;
    this.requiredFields = ["message"];
    this.fieldsName = {
      message: "Комментарий",
    };
  }

  clearForm = () => {
    this.submitted = false;
    this.setState({
      values: {
        message: "",
        files: [],
      },
    });
  };

  componentDidMount() {
    this.clearForm();
  }

  render(props, state, context) {
    if (!state.available) return;
    const errors = this.validate();

    return (
      <form className="form-block main__full-wd-xs">
        <div className="form-block__header">
          <h2 className="form-block__title">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z"
                fill="black"
              />
            </svg>
            Дополнить
          </h2>
        </div>
        <div className="form-block__section">
          <div
            className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
              errors.message ? "form-field_state_error" : ""
            }`}
          >
            <div className="form-field__inner">
              <div className="form-field__title-row">
                <label className="form-field__title" htmlFor="message">
                  Комментарий *
                </label>
              </div>
              <div className="form-field__input-row form-field__input-row_min-ht_none">
                <textarea
                  className="input input_textarea form-field__input false"
                  id="message"
                  placeholder="Ваш комментарий"
                  value={state.values.message}
                  onChange={this.onChangeInput("message")}
                />
              </div>
            </div>
          </div>

          {props.isTerminal ? (
            <CameraButton
              openModal={this.openModal}
              onDeleteFile={(file, field) => this.onDeleteFile(file)}
              field={"files"}
              values={this.state.values}
              errors={errors}
              getLabelField={() => "Прикрепить файл"}
            />
          ) : (
            <FileInput
              onChangeFile={(field) => this.onChangeFile}
              onDeleteFile={(file, field) => this.onDeleteFile(file)}
              field={"files"}
              values={this.state.values}
              errors={errors}
              getLabelField={() => "Прикрепить файл"}
            />
          )}
        </div>
        <div className="form-block__footer">
          {!!errors &&
            Object.values(errors).map((item) => {
              return <p className="form__error-text">{item}</p>;
            })}
          <button
            onClick={this.onSubmitForm}
            disabled={Object.keys(errors).length}
            className="button-primary button-primary_bgc_brand-2 form-block__footer-item form-block__footer-item_wd_md"
          >
            {this.state.loading ? "Отправка" : "Отправить"}
          </button>
        </div>
        {props.isTerminal && state.modalCamera && (
          <Modal
            onClose={this.closeModal}
            onChange={this.onChangeCameraInput}
          />
        )}
      </form>
    );
  }

  closeModal = () => {
    this.setState({ modalCamera: false });
  };

  openModal = () => {
    this.setState({ modalCamera: true });
  };

  onChangeCameraInput = (file, fileDataUrl) => {
    this.setValues({ files: [...this.state.values.files, file] });
  };

  isRequired = (fieldName) =>
    this.requiredFields.indexOf(fieldName) !== -1 ? "* " : "";

  validate = () => {
    let errors = {};
    if (!this.submitted) return errors;

    const self = this;
    const { values } = this.state;

    this.requiredFields.forEach((requiredField) => {
      if (
        typeof values[requiredField] === "undefined" ||
        values[requiredField] === null ||
        values[requiredField].length === 0
      ) {
        const fieldName =
          requiredField in self.fieldsName
            ? self.fieldsName[requiredField]
            : "";
        errors[requiredField] = `"${fieldName}" обязательно для заполнения`;
      }
    });

    if (values.message.length >= 500) {
      errors.message = '"Вопрос" не должен превышать 500 символов';
    }

    errors = {
      ...errors,
      ...validateFiles(
        values.files,
        maxCountFile,
        maxSizeFile,
        allowedFileTypes
      ),
    };

    return errors;
  };

  onChangeInput = (field) => (e) => {
    this.setValues({ [field]: e.target.value });
  };

  onChangeFile = (e) => {
    this.setValues({ files: [...this.state.values.files, ...e.target.files] });
  };

  onDeleteFile = (file) => (e) => {
    e.preventDefault();
    this.setValues({
      files: [...this.state.values.files.filter((item) => item !== file)],
    });
  };

  setValues = (values) => {
    this.setState({
      values: {
        ...this.state.values,
        ...values,
      },
    });
  };

  onSubmitForm = (e) => {
    e.preventDefault();
    const self = this;
    this.submitted = true;
    const errors = this.validate();
    if (Object.keys(errors).length) {
      this.forceUpdate();
      return;
    }

    this.setState({ loading: true });
    const formData = new FormData();
    const { values } = this.state;
    formData.append("appealId", this.props.appealId);
    formData.append("message", values.message);
    if (values.files.length) {
      values.files.forEach((item) => {
        formData.append("files[]", item);
      });
    }

    sendRequest(this.props.url, {
      body: formData,
      type: "POST",
      headers: { contentType: false, processData: false },
      showLoader: true,
    }).then((data) => {
      self.setState({ loading: false });
      if (data.status === 200) {
        this.clearForm();
        if (typeof this.props.onSubmited === "function") {
          this.props.onSubmited();
        }

        // this.setState({available: false});
      }
      if (data.status >= 500 || data.status === 0) {
        $.disMsg(
          "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
          { type: "false" }
        );
      }
    });
  };
}
